import { DomainCode } from '@australiangreens/ag-internal-components';
import { AutocompleteResult } from '@/types';
import { GeometryType } from '@/types/shared';
import { logger } from '@/util';
import callBackendApi from './call';

export { GeometryType };

export interface GeometryRecord {
  id: number;
  label: string;
  geometryType: GeometryType;
}

export const getGeometriesContaining = async (
  token: string,
  containedString: string,
  filterBySub?: { sub: string; domainCode: DomainCode },
  abortSignal?: AbortSignal
) => {
  logger.debug('getGeometriesContaining() called', { containedString, filterBySub });

  const queryStr = filterBySub
    ? `?filterBySub=${filterBySub.sub}&domainCode=${filterBySub.domainCode}`
    : '';

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/geometries/containing/${encodeURIComponent(containedString)}${queryStr}`,
    abortSignal,
  });

  return data as GeometryRecord[];
};

export const getGeometries = async (
  token: string,
  geometryIds: number[],
  filterBySub?: { sub: string; domainCode: DomainCode },
  abortSignal?: AbortSignal
) => {
  logger.debug('getGeometries() called', { geometryIds, filterBySub });

  const queryStr = filterBySub
    ? `?id=${JSON.stringify(geometryIds)}&filterBySub=${filterBySub.sub}&domainCode=${
        filterBySub.domainCode
      }`
    : '';

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/geometries/${queryStr}`,
    abortSignal,
  });

  return data as GeometryRecord[];
};

// This method takes 'values' as an argument - a sequence of AutocompleteResult
// items, which correspond to a list of Geometries found in a search. It returns a
// sequence (sometimes smaller, sometimes empty) of AutocompleteResult items;
// these indicate the Geometries which are valid for the current user (as indicated
// by token).

export const validateGeometries = async (
  token: string,
  values: AutocompleteResult[],
  domainCode: string
) => {
  logger.debug('validateGeometries() called', {});
  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/geometries/validate?values=${encodeURIComponent(
      JSON.stringify(values)
    )}&domainCode=${domainCode}`,
  });
  return data as AutocompleteResult[];
};
